import { forwardRef, useState } from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import PropTypes from 'prop-types';

const RangeField2 = forwardRef((props, ref) => {
    const { onChange, ...other } = props;
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        allowLeadingZeros
        valueIsNumericString={true}
        allowNegative={false}
        decimalScale={0}
        thousandsGroupStyle={''}
        onValueChange={(values) => {
          onChange(values.value);
        }}
      />
    );
  }
);

const RangeField = forwardRef((props, ref) => {
  
  const { onChange, onFocus, onBlur, name, value, ...other } = props;
  const [focused, setFocused] = useState(false);

  return (
    <PatternFormat
      key={focused ? "focused" : "blurred"}
      {...other}
      getInputRef={ref}
      value={value ?? ""}
      format="########"
      mask={focused ? "_" : ""}
      allowEmptyFormatting={focused}
      //isAllowed={(values) => values.value.length <= 8}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.value
          }
        });
      }}
    />
  );
});

RangeField.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default RangeField;